import { render, staticRenderFns } from "./BottomBarComponent.vue?vue&type=template&id=a59e757e&scoped=true&"
import script from "./BottomBarComponent.vue?vue&type=script&lang=js&"
export * from "./BottomBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e757e",
  null
  
)

export default component.exports